import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-export-ftp',
  templateUrl: './help-add-export-ftp.component.html',
  styleUrls: ['./help-add-export-ftp.component.scss']
})
export class HelpAddExportFtpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
